module.exports = __webpack_public_path__ + "static/media/creative-commons-pd-alt.d5230261.svg";